import React from 'react';
import { Link } from 'react-router-dom';

import EDSFooter from '../components/EDSFooter';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../components/Elements/header/header';
import CustomButtons from '../components/Elements/Buttons/customButton';
import './main.css';
const Login_haslo_zmienione = () => {
    const [header, setHeader] = useState('/  AKTYWACJA KONTA');
    
    const history = useHistory();
    var currentLocation = window.location;
    let key
    console.log(currentLocation.href.split("/"))
    if(currentLocation.href.split("/")[4]!= undefined &&currentLocation.href.split("/")[4].split("=")[1] != undefined){
        key = currentLocation.href.split("/")[4].split("=")[1]
    }

    const goToLogin = () => {
        let linkToPush;
        if (key == '' || key == null || key == undefined) {
            linkToPush = '/LoginBuy';
        } else {
            linkToPush = '/LoginBuy/key=' + key;
        }

        history.push(linkToPush);
    };

    let url = '/';
    if (key) {
        url = '/key/' + key.toString();
    }
    return (
        <>
            <Header>{header}</Header>
            <div className="content responsive-padding">
                <main className="margin-top-64">
                    <div className="tittle_wraper">
                        <p className="tittle_register tittleChangePassSucces">TWOJE KONTO ZOSTAŁO AKTYWOWANE</p>
                    </div>
                    <div style={{ marginTop: '30px' }}>
                        <CustomButtons
                            clickFunction={(e) => {
                                goToLogin();
                            }}
                            classButton="solid"
                            size="big"
                        >
                            PRZEJDŹ DALEJ
                        </CustomButtons>
                    </div>
                </main>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Login_haslo_zmienione;
